import React from 'react';
import { useLocation } from 'react-router-dom';

// The home page draws its own hero glow
export function PageGlow() {
  const { pathname } = useLocation();
  if (pathname === '/') return null;

  return (
    <div className="page-glow" aria-hidden="true">
      <span />
      <span />
      <span />
      <span />
    </div>
  );
}
